import React from 'react';
import { realValues, isCategorizedSkills, splitSkill, validCerts, certMeta } from './contactUtils';

/** Maximum information density — best for content-heavy resumes that must fit one page. */
export default function MinimalTemplate({ resume }) {
  if (!resume) return null;
  const c = resume.contact || {};

  return (
    <div style={{ fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', maxWidth: '680px', margin: '0 auto', padding: '22px 28px', fontSize: '10px', lineHeight: '1.45', color: '#111', background: '#fff' }}>
      {/* Header */}
      <div style={{ marginBottom: '8px' }}>
        <span style={{ fontSize: '18px', fontWeight: '700' }}>{c.name}</span>
        <span style={{ color: '#555', marginLeft: '12px', fontSize: '9px' }}>
          {realValues([c.email, c.phone, c.location, c.linkedin]).join('  ·  ')}
        </span>
      </div>
      <hr style={{ border: 'none', borderTop: '1px solid #ccc', margin: '0 0 8px' }} />

      {resume.summary && (
        <Row label="SUMMARY">
          <p style={{ margin: 0 }}>{resume.summary}</p>
        </Row>
      )}

      {resume.skills?.length > 0 && (
        <Row label="SKILLS">
          {isCategorizedSkills(resume.skills) ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              {resume.skills.map((s, i) => {
                const { label, rest } = splitSkill(s);
                return <div key={i}>{label ? <><strong>{label}:</strong> {rest}</> : <>·&nbsp;{s}</>}</div>;
              })}
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', columnGap: '10px', rowGap: '1px' }}>
              {resume.skills.map((s, i) => <span key={i}>·&nbsp;{s}</span>)}
            </div>
          )}
        </Row>
      )}

      {resume.experience?.length > 0 && (
        <Row label="EXPERIENCE">
          {resume.experience.map((exp, i) => (
            <div key={i} style={{ marginBottom: '8px' }}>
              <div>
                <strong>{exp.company}</strong>
                <span style={{ color: '#444', marginLeft: '6px' }}>{exp.title}</span>
                <span style={{ color: '#888', float: 'right', fontSize: '9px' }}>{exp.dates}</span>
              </div>
              <ul style={{ margin: '2px 0 0', paddingLeft: '12px' }}>
                {exp.bullets?.map((b, j) => <li key={j} style={{ marginBottom: '1px' }}>{b}</li>)}
              </ul>
            </div>
          ))}
        </Row>
      )}

      {resume.education?.length > 0 && (
        <Row label="EDUCATION">
          {resume.education.map((edu, i) => (
            <div key={i} style={{ marginBottom: '3px' }}>
              <strong>{edu.institution}</strong>
              <span style={{ color: '#444', marginLeft: '6px' }}>{edu.degree}</span>
              <span style={{ color: '#888', float: 'right', fontSize: '9px' }}>{edu.dates}</span>
            </div>
          ))}
        </Row>
      )}

      {validCerts(resume).length > 0 && (
        <Row label="CERTIFICATIONS">
          {validCerts(resume).map((cert, i) => (
            <div key={i} style={{ marginBottom: '3px' }}>
              <strong>{cert.name}</strong>
              <span style={{ color: '#888', float: 'right', fontSize: '9px' }}>{certMeta(cert, '  ·  ')}</span>
            </div>
          ))}
        </Row>
      )}
    </div>
  );
}

function Row({ label, children }) {
  return (
    <div style={{ display: 'flex', gap: '10px', marginBottom: '7px' }}>
      <div style={{ width: '68px', flexShrink: 0, fontSize: '8px', fontWeight: '700', letterSpacing: '0.8px', color: '#888', paddingTop: '1px', textTransform: 'uppercase' }}>{label}</div>
      <div style={{ flex: 1, borderLeft: '1px solid #e5e5e5', paddingLeft: '10px' }}>{children}</div>
    </div>
  );
}
